import { Platform } from 'react-native';

const copyToClipboard = async (text: string) => {
  try {
    if (Platform.OS === 'web') {
      console.log('Copied to clipboard:', text);
      alert('Reference number copied')
      await navigator.clipboard.writeText(text);
    } else {
      // @ts-ignore: dynamic import is supported at runtime
      // const Clipboard = await import("expo-clipboard");
      // await Clipboard.setStringAsync(text);
    }
    console.log('Copied to clipboard:', text);
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};

export default copyToClipboard;